import { observable, action, decorate } from 'mobx';
import { PAGE_LOADER, INLINE_LOADER } from '../logic/Constants';

class InteractStore {
  modals: Record<string, boolean> = {};

  submitting: Record<string, boolean> = {};

  openModal(id: string) {
    this.modals[id] = true;
  }

  closeModal(id: string) {
    this.modals[id] = false;
  }

  isModalOpen(id: string) {
    return this.modals[id];
  }

  isSubmitting() {
    return this.submitting[INLINE_LOADER];
  }

  isPageSubmitting() {
    return this.submitting[PAGE_LOADER];
  }

  startSubmit(id: string) {
    this.submitting[id] = true;
  }

  stopSubmit(id: string) {
    this.submitting[id] = false;
  }
}

decorate(InteractStore, {
  modals: observable,
  submitting: observable,
  openModal: action,
  closeModal: action,
  startSubmit: action,
  stopSubmit: action,
});

export default InteractStore;
